// extracted by mini-css-extract-plugin
export default {"prizesTableContainer":"PrizesTable_prizesTableContainer__siZrZ","prizesTable":"PrizesTable_prizesTable__EuZf+"};